import { PageContent, PageHeader, PageShell } from "../../components/layout/PageShell";
import { COLORS, RADIUS } from "../../shared/theme";
import {
  MdAssignment,
  MdBusiness,
  MdOutlineGavel,
  MdSecurity,
  MdShield,
  MdThumbUp,
} from "react-icons/md";

const DOMAINES_CONFIG = [
  { key: "ropa", label: "ROPA (Registre)", icon: <MdAssignment size={18} />, desc: "Traitements documentés" },
  { key: "gouvernance", label: "Gouvernance", icon: <MdOutlineGavel size={18} />, desc: "Preuves et activités RGPD" },
  { key: "soustraitance", label: "Sous-traitance", icon: <MdBusiness size={18} />, desc: "Sous-traitants et DPA" },
  { key: "incidents", label: "Incidents", icon: <MdSecurity size={18} />, desc: "Registre des incidents" },
  { key: "droits", label: "Droits des personnes", icon: <MdShield size={18} />, desc: "Demandes d'exercice de droits" },
  { key: "consentements", label: "Consentements", icon: <MdThumbUp size={18} />, desc: "Points de collecte et retraits" },
];

const STORAGE_KEY = "rgpd_domain_declarations";

function loadDeclarations() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      return { ...Object.fromEntries(DOMAINES_CONFIG.map(d => [d.key, false])), ...parsed };
    }
  } catch (_) {}
  return Object.fromEntries(DOMAINES_CONFIG.map(d => [d.key, false]));
}

export default function PageDashboardConfig({ domainDeclarations, setDomainDeclarations, onBack }) {
  const local = { ...Object.fromEntries(DOMAINES_CONFIG.map(d => [d.key, false])), ...domainDeclarations };

  const handleToggle = (key) => {
    const next = { ...local, [key]: !local[key] };
    setDomainDeclarations(next);
  };

  return (
    <PageShell>
      <PageHeader
        title="Configuration du tableau de bord"
        subtitle="Déclarez « Rien à déclarer » pour les domaines vides afin d'afficher un score"
        onBack={onBack}
        backLabel="← Retour"
      />

      <PageContent>
        <div style={{ maxWidth: 720 }}>
        <div style={{ background: "#eff6ff", border: "1.5px solid #bfdbfe", borderRadius: RADIUS.lg, padding: "14px 18px", marginBottom: 24 }}>
          <div style={{ fontSize: 13, color: "#1e40af", lineHeight: 1.6 }}>
            Pour les domaines sans données (ROPA vide, aucun sous-traitant, etc.), le tableau de bord affiche « Inconnu » par défaut. Cochez « Rien à déclarer » si ce domaine ne s'applique pas à votre organisation — un score de 100 % sera alors affiché pour ce domaine.
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {DOMAINES_CONFIG.map(d => (
            <div
              key={d.key}
              style={{
                background: COLORS.white,
                borderRadius: RADIUS.lg,
                border: `1.5px solid ${COLORS.border}`,
                padding: 16,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
              }}
            >
              <div>
                <div style={{ fontWeight: 700, fontSize: 14, color: COLORS.textPrimary, display: "inline-flex", alignItems: "center", gap: 8, lineHeight: 1.2 }}>
                  <span style={{ display: "inline-flex", alignItems: "center", lineHeight: 1 }}>{d.icon}</span>
                  <span>{d.label}</span>
                </div>
                <div style={{ fontSize: 12, color: COLORS.textSecondary, marginTop: 2 }}>{d.desc}</div>
              </div>
              <label style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer", flexShrink: 0 }}>
                <input
                  type="checkbox"
                  checked={!!local[d.key]}
                  onChange={() => handleToggle(d.key)}
                  style={{ width: 18, height: 18, cursor: "pointer" }}
                />
                <span style={{ fontSize: 13, fontWeight: 600, color: "#374151" }}>Rien à déclarer</span>
              </label>
            </div>
          ))}
        </div>
        </div>
      </PageContent>
    </PageShell>
  );
}

export { loadDeclarations, STORAGE_KEY };
